<template>
  <td class="optInOut">
    <ul class="listOptInOut d-flex p-0 m-0">
      <li v-for="(item, index) in model" :key="item.id + index" class="mx-2" :style="{ opacity: item.status ? 1 : 0.3 }">
        <CIcon :title="item.title" :name="item.name" size="custom-size" :height="20" :viewBox="item.viewBox" />
      </li>
    </ul>
  </td>
</template>

<script>
export default {
  name: 'OptInOut',
  props: {
    opt: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      model: {
        EMAIL: { name: 'email', title: 'e-mail', viewBox: '0 0 32 32', status: false, id: null },
        SMS: { name: 'sms', title: 'SMS', viewBox: '0 0 38 32', status: false, id: null },
        // VOICE:{name:"voice", title: "Voice",  viewBox: '0 0 32 32',  status: false},
        // PUSH_NOTIFICATION:{name:"pushNotification",  title: "Push Notification", viewBox: '0 0 32 32',  status: false}
      },
    }
  },
  mounted() {},
  watch: {
    opt: {
      handler(data) {
        data.item._MetaData.Subscriptions.forEach(item => {
          if (this.model[item]) {
            this.model[item].status = true
            this.model[item].id =
              '_' +
              Math.random()
                .toString(36)
                .substr(2, 9)
          }
        })
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
